import { Form, Input, type FormItemProps, type InputProps } from "antd";

interface Props extends FormItemProps {
  inputProps?: InputProps;
}

export default function FormItemInput({ inputProps, ...rest }: Props) {
  return (
    <Form.Item {...rest} className={`${rest.className} mb-0!`}>
      <Input {...inputProps} />
    </Form.Item>
  );
}
